import script from "./ImageSupplier.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageSupplier.vue?vue&type=script&setup=true&lang=ts"

import "./ImageSupplier.vue?vue&type=style&index=0&id=055243ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055243ef"]])

export default __exports__